import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import * as Style from '../components/styled-components/Myhhs'
import Grid from '@mui/material/Grid'
import { ThemeProvider } from '@mui/material/styles'
import { Divider, Select, MenuItem, Toolbar, IconButton, Container, ListItemButton, ListItemIcon } from '@mui/material'
import MenuIcon from '@mui/icons-material/Menu'
import massHealthLogo from '../assets/images/massHealth.png'
import '../styles/header.scss'
import { useLocation, useNavigate } from 'react-router-dom'
import TopMenuItems from './TopMenuItems'
import TopMenu from './TopMenu'
import Footer from './Footer'
import SwipeableTemporaryDrawer from './SideMenu'
import { themeLayout, logout } from '../components/Style'
import config from 'config/config'
import { connect } from 'react-redux'
import { getLanguage, changeLanguage, showFeedBack } from '../store/actions/languageActions'
import { useMsal } from '@azure/msal-react'
import ReactGA from 'react-ga4'
import { getClientInfo, azureLogOut, clearSession } from '../store/actions/auth'
import { getTransLang } from '../components/MultiLanguage/dynamic-content-translate'
import Language from '../assets/images/Language.svg'
import Settings from '../assets/images/Settings.svg'
import Logout from '../assets/images/Logout.svg'
import Profile from '../assets/images/MyInfo-icon-old.svg'
import * as TextProps from '../constants/text'
const MainLayout = (props) => {
  const location = useLocation()
  const navigate = useNavigate()
  const [linkAccount, setLinkAccount] = useState(!!location?.state?.linkAccount)
  const selectedLanguage = props?.langDetails?.currentLanguage
  const [layout, setLayout] = useState(props?.langDetails?.constantStrings)
  const [open, setOpen] = useState(false)
  const { instance } = useMsal()
  const lang = props.langDetails.currentLanguage
  const translateMenu = (name) => {
    return getTransLang(lang)[name]
  }
  useEffect(() => {
    setLinkAccount(props?.children?.props?.access)
  }, [props])

  const handleDrawerOpen = () => {
    setOpen(true)
  }
  useEffect(() => {
    setLayout(props?.langDetails?.constantStrings)
  }, [JSON.stringify(props?.langDetails), lang])

  useEffect(() => {
    if (typeof props?.authDetails?.loginDetails?.data?.firstName !== 'string') {
      props?.getClientInfo(instance)
    }
  }, [])

  const userInfo = props?.authDetails?.loginDetails?.data
  const isAdminOrCW = userInfo?.roles?.find((role) => role === TextProps.ADMUSR || role === TextProps.CSDRWK || role === TextProps.CSWRKR)
  const activeMenu = location.pathname.slice(1).split('/')[0]
  let menuDetails = null
  if (activeMenu !== 'myaccounts') {
    menuDetails = TopMenuItems.filter((menu) =>
      menu.route.toLowerCase().includes(activeMenu)
    )
  }
  const signOutClickHandler = () => {
    ReactGA.event({ category: 'Logout', action: 'Logout', label: 'Logout' })
    props.clearSession()
    props.azureLogOut(instance)
  }
  const navigateToMyAccount = () => {
    navigate('/myaccounts')
  }
  const onLanguageSelection = (e) => {
    ReactGA.event({ category: 'Language selector', action: 'Selected Language', label: e.target.value })
    localStorage.setItem('language', e.target.value)
    // window.location.reload()
    props.changeLang(e.target.value)
  }
  return (
    <ThemeProvider theme={themeLayout}>
      <Grid container sx={{ background: activeMenu.toLowerCase() === 'dashboard' ? config.colors.white : config.colors.verylightshadegray }} className="layoutContainer">
        <Grid container className="layoutInnerContainer">
          <Grid xs={12} md={12} lg={12} item className='displaySideMenu'>
            <Toolbar className="toggleDrawer">
              <IconButton aria-label="open drawer" onClick={handleDrawerOpen} className="dark-blue">
                <MenuIcon />
              </IconButton>
              <Grid item className='logoGrid'>
                <ListItemButton tabIndex={1} key={'logo'} href={isAdminOrCW ? '/landing' : '/dashboard'} sx={{ padding: 0 }} onClick={() => { window.sessionStorage.setItem('linkId', ''); props.clearSession() }}>
                  <ListItemIcon sx={[config.minW24]}>
                    <img src={massHealthLogo} height="64" width="65" alt="Home of MyServices" />
                  </ListItemIcon>
                  <h1 role='heading' className="logo-layout-text" data-testid="logo-text"> {layout?.productName}</h1>
                </ListItemButton>
              </Grid>
              {menuDetails !== null
                ? (<span className="t-decorate-none blue w-100 txt-center">
                  <img src={menuDetails[0]?.icon} alt={menuDetails[0]?.name} height="20" width="20" className="sideMenuTitleImg" />
                  {translateMenu(menuDetails[0]?.name)}
                </span>)
                : ('')}
              <SwipeableTemporaryDrawer language={selectedLanguage} onLangChange={(lang) => {
                localStorage.setItem('language', lang)
              }} isOpen={open} setChange={(open) => { setOpen(open) }} layout={layout} />
            </Toolbar>
          </Grid>
          <Grid item className="displayLogoGrid logoOuterGrid">
            <Grid className="logoGrid cursor-pointer">
              <ListItemButton tabIndex={1} key={'logo'} aria-label="MyServices Logo" href={isAdminOrCW ? '/landing' : '/dashboard'} sx={{ padding: 0 }} onClick={() => window.sessionStorage.setItem('linkId', '')}>
                <ListItemIcon sx={[config.minW24]}>
                  <img src={massHealthLogo} height="64" width="65" alt="Home of MyServices" />
                </ListItemIcon>
                <h1 role='heading' className="logo-layout-text" data-testid="logo-text"> {layout?.productName}</h1>
              </ListItemButton>
            </Grid>
            <Divider orientation="vertical" flexItem />
          </Grid>
          <Grid role="navigation" item className="displayTopMenu topMenuGrid">
            <TopMenu linkAccount={linkAccount} />
          </Grid>
          <Grid item className="displayRightMenu languageGrid">
            <Grid item display={{ xs: 'none', sm: 'none', xl: 'flex', lg: 'flex', md: 'none' }} className="demo-simple-select topMenuLinkLang textCenterAlign">
              <img src={Language} alt={'select language'} height="19" width="19" className='iconStyle' />
              <select aria-label='select language' className="language-select header" defaultValue={selectedLanguage} onChange={onLanguageSelection}>
                {
                  config.languages.map((item, i) => {
                    return <option key={i} value={item.value}>{item.key}</option>
                  })
                }
              </select>
            </Grid>
            <Divider orientation="vertical" flexItem />
            <Grid item display={{ xs: 'none', sm: 'none', xl: 'flex', lg: 'flex', md: 'none' }} className="demo-simple-select topMenuLink textCenterAlign">
            <Select labelId="label" id="select" value="0" sx={logout} MenuProps={{ style: { maxWidth: 0, maxHeight: 300, position: 'absolute' }, disableScrollLock: true }}>
              <MenuItem value={0} tabIndex="0" style={{ display: 'none' }}>
              <span className="cursor-pointer black textCenterAlign">
                <img src={Profile} height="19" width="19" className='iconStyle' alt='user logo' />
                <div className="t-decorate-underline name-spacing" style={{ color: '#002a57' }}>{userInfo?.firstName}</div>
              </span>
              </MenuItem>
              <MenuItem value={1} tabIndex="-2" onClick={navigateToMyAccount} className="blue t-decorate-underline textCenterAlign">
                <img src={Settings} height="16" width="16" style={{ marginRight: '5px' }} alt='Settings' />{layout?.settings}
              </MenuItem>
              <Divider />
              <MenuItem value={2} tabIndex="-1" onClick={signOutClickHandler} className="blue t-decorate-underline textCenterAlign">
                <img src={Logout} alt="logout" height="16" width="16" style={{ marginRight: '5px' }} />{layout?.logout}
              </MenuItem>
            </Select>
            </Grid>
          </Grid>
        </Grid>
        <Grid sx={{ mt: 2, background: activeMenu.toLowerCase() === 'dashboard' ? config.colors.white : config.colors.verylightshadegray }}
          item display="flex" justifyContent="center" className="spacing-mbl" xs={12} xl={12} lg={12} md={12}>
          <Style.Content>{props?.children}</Style.Content>
        </Grid>
        <Container className="footer" sx={{ m: 0 }}>
          <Grid container className="footer-container" sx={[config.width64]}>
            <Footer />
          </Grid>
        </Container>
      </Grid>
    </ThemeProvider>
  )
}

const mapStateToProps = (state) => ({ langDetails: state.language, authDetails: state.auth, feedBackFlag: state.flag })

const mapDispatchToProps = (dispatch) => {
  return {
    onGetLanguage: (lang) => dispatch(getLanguage(lang)),
    azureLogOut: (instance) => dispatch(azureLogOut(instance)),
    clearSession: () => dispatch(clearSession()),
    getClientInfo: (msal) => dispatch(getClientInfo(msal)),
    changeLang: (lan) => dispatch(changeLanguage(lan)),
    feedBack: (flag) => dispatch(showFeedBack(flag))
  }
}

MainLayout.propTypes = {
  children: PropTypes.node.isRequired,
  onGetLanguage: PropTypes.func,
  getClientInfo: PropTypes.func,
  langDetails: PropTypes.object,
  authDetails: PropTypes.object,
  azureLogOut: PropTypes.func,
  clearSession: PropTypes.func,
  feedBackFlag: PropTypes.object,
  feedBack: PropTypes.func
}

export default connect(mapStateToProps, mapDispatchToProps)(MainLayout)
